import { Option } from '@/components/Form';
import { FeatureKeys } from '@/config';
import { TransitionGapOption } from '@/features/analyze/types';

export const DURATION_GAPS: Option<TransitionGapOption>[] = [
  { label: '3 Months', value: 'QUARTER' },
  { label: '1 Month', value: 'MONTH' },
  { label: '1 Week', value: 'WEEK' },
] as const;

export const INITIAL_PER_PAGE = {
  search: 10,
  treemap: 50,
  transition: 10,
};

export const ANALYZE_METHODS = [
  'search',
  FeatureKeys.treemap,
  FeatureKeys.transition,
] as const;

export const SHOW_ALL_FACETS = -1;

export const SOLR_REQUEST = {
  FACET_SORT: 'count',
  DOCS_SORT: 'published_at desc',
  DOCS_FIELDS: [
    'id',
    'title',
    'summary',
    'url',
    'image_url',
    'summary',
    'published_at',
    'organization',
    'organization_type',
    'country',
    'country_tags',
    'people',
    'companies',
    'locations',
    'themes',
    // tag を利用したい場合は、warn: tags_${theme_name} を追加すること
  ],
};

export const MIN_PUBLISHED_AT = new Date(2019, 0, 1);

// z-index管理（用途ごとに一括管理）
export const Z_INDEX = {
  FILTER_DL_BUTTON: 10, // Filter画面下部のDLボタン
  FACET_SELECT_MENU_PORTAL: 110, // Facetプルダウンメニュー（DLボタンより上に表示）
};
